export enum BadgeType {
    ERROR = 'sh-badge--error',
    WARNING = 'sh-badge--warning',
    SUCCESS = 'sh-badge--success',
    UPDATE = 'sh-badge--update'
}
export interface Badge {
    readonly count: number;
    readonly type: BadgeType;
}

export enum BadgeSize {
    REGULAR = '',
    SMALL = '-sh-small'
}
